export default __webpack_public_path__ + "static/Sachin3-fec79bb9525cc0b8676949893d4c4fb5.jpg";